import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getEmojiFromCode } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'

export default function UserNameTooltip({ entity, showModal, isPrompt = false, isReaction = false }) {
  const { t } = useTranslation()

  const getUserNames = (users) => {
    const names = users.map(({ firstname, lastname }) => `${firstname} ${lastname[0]}`)
    const finalName = names.pop()
    return names.length ? names.join(', ') + ' & ' + finalName : finalName
  }

  const [emoji, setEmoji] = useState(null)

  useEffect(() => {
    if (entity?.unified_unicode) {
      const emojiCode = getEmojiFromCode(entity.unified_unicode)
      setEmoji(emojiCode)
    }
  }, [entity])

  const getUserNamesWithMore = (users) => {
    const names = users
      .slice(0, 3)
      .map(({ firstname, lastname }) => `${firstname} ${lastname[0]}`)
      .join(', ')
    const remainingCount = users.length - 3
    return t('messenger.reactionTooltipMoreUsers', { names, remainingCount })
  }
  return (
    <div className={styles.tooltipContainer}>
      {isReaction && <div className={styles.emoji}>{emoji}</div>}

      {entity.users.length === 1 ? (
        <span
          className={`${styles.reactedByName} ${
            isPrompt && styles.promptUserName
          }`}>{`${entity.users[0].firstname} ${entity.users[0].lastname}`}</span>
      ) : entity.users.length === 2 ? (
        <span className={`${styles.reactedByName} ${isPrompt && styles.promptUserName}`}>
          {entity.users.map((user) => user.firstname + ' ' + user.lastname).join(' & ')}
        </span>
      ) : entity.users.length <= 4 ? (
        <span className={`${styles.reactedByName} ${isPrompt && styles.promptUserName}`}>
          {getUserNames(entity.users)}
        </span>
      ) : (
        <button
          className={`${styles.reactedByName} ${isPrompt && styles.promptUserName} ${styles.reactedByNameButton}`}
          onClick={() => showModal(entity)}>
          {getUserNamesWithMore(entity.users)}
        </button>
      )}
    </div>
  )
}
